import React,{useState} from "react";
import "./Sidemenu.css";
import { Link, useHistory } from "react-router-dom";
import {
  UserAddOutlined,
  FileAddOutlined,
  FundViewOutlined,
  DeliveredProcedureOutlined,
  RiseOutlined,
  UnorderedListOutlined,
  FormOutlined,
  LogoutOutlined,
  FieldTimeOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import logo from "../../Jlb.png";

function Sidemenu(prop) {
  const history = useHistory();
 

  const [activeLink, setActiveLink] = useState("");
  const handleClick = (link) => {
    setActiveLink(link);
  };


  const Logouthandler = () => {
    if (window.confirm("Do you really want log out?")) {
      localStorage.removeItem("token-2");

      history.push("/login");
    }
  };

  return (
    <div className="main-sidemenu">
      <div className="main-logo-jlb">
        <img src={logo}></img>
      </div>
      <div
       className={`member-side ${activeLink === "member" ? "active" : ""}`}
        onClick={() => {
          prop.setupdate(Date.now());
          handleClick("member")
     
        }}
   
   
      >
        <UserAddOutlined />
        <Link to="/admin/member" > Membership Form</Link>
      </div>
      <div
               className={`member-side ${activeLink === "newmiti" ? "active" : ""}`}
        onClick={() => {
          prop.setupdate(Date.now());
          handleClick("newmiti")
        }}
      >
        <FileAddOutlined />
        <Link to="/admin/mittiDetails">New Mitti</Link>
      </div>
      {/* <div
         className={`member-side ${activeLink === "display" ? "active" : ""}`}
        onClick={() => {
          prop.setupdate(Date.now())
          handleClick("display")
        }}
      >
        <FundViewOutlined />
        <Link to="/admin/displayDates">Display Dates</Link>
      </div> */}



      <div
        className={`member-side ${activeLink === "calenderwise" ? "active" : ""}`}
        onClick={() => {
          prop.setupdate(Date.now());
          handleClick("calenderwise")
        }}
      >
        <FieldTimeOutlined />
        <Link to="/admin/calender">Display Dates</Link>
      </div>





      <div
      className={`member-side ${activeLink === "mitireport" ? "active" : ""}`}
        onClick={() => {
          prop.setupdate(Date.now());
          handleClick("mitireport")
        }}
      >


        
        <DeliveredProcedureOutlined />
        <Link to="/admin/mittiReports"> Mitti Report </Link>
      </div>
      <div
            className={`member-side ${activeLink === "Allmembers" ? "active" : ""}`}
        onClick={() => {
          prop.setupdate(Date.now());
          handleClick("Allmembers")
        }}
      >
        <UnorderedListOutlined />
        <Link to="/admin/allmembers">All Members List</Link>
      </div>
      <div className={`member-side ${activeLink === "Outstanding" ? "active" : ""}`}
        onClick={() => {
          prop.setupdate(Date.now());
          handleClick("Outstanding")
        }}
      >
        <RiseOutlined />
        <Link to="/admin/Outstanding">Outstanding Reports</Link>
      </div>
      <div className={`member-side ${activeLink === "DisplayDatesReports" ? "active" : ""}`}
        onClick={() => {
          prop.setupdate(Date.now());
          handleClick("DisplayDatesReports")
        }}>
        <FormOutlined />
        <Link to="/admin/display-date-report">Display Dates Reports</Link>
      </div>
{/* 
      <div
        className={`member-side ${activeLink === "calenderwise" ? "active" : ""}`}
        onClick={() => {
          prop.setupdate(Date.now());
          handleClick("calenderwise")
        }}
      >
        <FieldTimeOutlined />
        <Link to="/admin/calender">Calender Wise</Link>
      </div> */}
      <div
        className={`member-side ${activeLink === "OliaDisplay" ? "active" : ""}`}
        onClick={() => {
          prop.setupdate(Date.now());
          handleClick("OliaDisplay")
        }}
      >
        <FieldTimeOutlined />
        <Link to="/admin/olia">Olia Display</Link>
      </div>
      <div
       className={`member-side ${activeLink === "Setting" ? "active" : ""}`}
        onClick={() => {
          prop.setupdate(Date.now());
          handleClick("Setting")
        }}
      >
        <SettingOutlined />
        <Link to="/admin/setting">Setting</Link>
      </div>
      <div className="member-side" onClick={Logouthandler}>
        <LogoutOutlined />
        <span>Logout</span>
      </div>
    </div>
  );
}

export default Sidemenu;
